import React, { useState } from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Image, DatePicker, InputNumber, Modal, List as ListAntd } from 'antd';
import { MemberService } from "./../../services/MemberService";
import {
    DeleteOutlined
} from "@ant-design/icons";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';
// import { CKEditor } from '@ckeditor/ckeditor5-react';

// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';

// import 'ckeditor5/ckeditor5.css';
import CreateConfigBenefit from './CreateConfigBenefit';
import Editor from '../../components/ckeditor/Editor';

const { TextArea } = Input

interface Props {
    record: any
    onFinish: () => void
}

export default function CreateConfig(props: Props) {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [form] = Form.useForm();
    const [conditions, setConditions] = useState<string>("")
    const [benefits, setBenefits] = useState<Array<any>>([])
    const [cashbackRatePercent, setCashbackRatePercent] = React.useState<number | null>(0)


    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
        })
        setConditions(props?.record?.conditions);
        setBenefits(props?.record?.benefits)
        setCashbackRatePercent(props?.record?.cashback_rate)
    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {
        if (props?.record?.id) {
            var res = await MemberService.updateCustomerLevelConfig(values, props.record.id)
        } else {
            var res = await MemberService.saveCustomerLevelConfig(values)
            form.resetFields();
        }

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };

    const deleteBenefitConfig = async (id: string, index: number) => {
        const res = await MemberService.deleteCustomerLevelBenefitConfig(id)
        if (res?.status == 1) {
            benefits.splice(index, 1)
            setBenefits([...benefits])
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }


    }


    return (
        <Card
            bordered={false}>
            <Modal
                title=""
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateConfigBenefit
                    customerLevelId={props?.record?.id}
                    onFinish={(benefits) => {
                        setIsModalOpen(false)
                        setBenefits(benefits)
                    }}
                ></CreateConfigBenefit>
            </Modal>
            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    level_name: '',
                    level_name_desc: '',
                    total_transaction: 0,
                    accu_volume: 0,
                    conditions: '',
                    accu_volume_currency: '',
                    sort_level: 0,
                    // commission_rate: 0,
                    cashback_rate: 0
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Level Name"
                    name="level_name"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Level Name Desc"
                    name="level_name_desc"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <TextArea rows={5} />
                </Form.Item>

                <Form.Item
                    label="Min Transaction"
                    name="total_transaction"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Min Accu Volume"
                    name="accu_volume"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Benefit"
                    name="benefit"
                    extra="Support .jpg,.jpeg,.png only"
                    rules={[{ required: false, message: 'Please fill field' }]}
                >

                    {
                        benefits?.map((item: any, index: number) => {
                            return (
                                <ListAntd key={`${item.id}`}>
                                    <ListAntd.Item

                                        extra={
                                            <Button type="primary"
                                                onClick={() => deleteBenefitConfig(item.id, index)}
                                                danger icon={<DeleteOutlined></DeleteOutlined>}></Button>
                                        }
                                    >
                                        <ListAntd.Item.Meta
                                            avatar={<Image src={item.fullPath} width={50} height={50} />}
                                            title={item.subject}
                                            description=""
                                        />
                                    </ListAntd.Item>
                                </ListAntd>
                            )
                        })
                    }


                    <Button size='small' onClick={() => { setIsModalOpen(true) }}>+</Button>
                </Form.Item>


                <Form.Item
                    label="Conditions"
                    name="conditions"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >



                    {/* <CKEditor
                        config={{
                            licenseKey: 'eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3MzcxNTgzOTksImp0aSI6IjhlNTYwMjMwLWJlNjgtNDQ5Zi04NjYxLTU0M2IwYjNjM2JmZSIsInVzYWdlRW5kcG9pbnQiOiJodHRwczovL3Byb3h5LWV2ZW50LmNrZWRpdG9yLmNvbSIsImRpc3RyaWJ1dGlvbkNoYW5uZWwiOlsiY2xvdWQiLCJkcnVwYWwiLCJzaCJdLCJ3aGl0ZUxhYmVsIjp0cnVlLCJsaWNlbnNlVHlwZSI6InRyaWFsIiwiZmVhdHVyZXMiOlsiKiJdLCJ2YyI6IjViMTY3NmM4In0.IkdqVZ_zLM3X3YNcPFTpy6KzA6g_sK9B4WWypgkZYdzgTsGde-RYF7jX1uJQBQYuBJCYSlzj_REFBb6AMmWopQ',
                            plugins: [Essentials, Paragraph, Bold, Italic, List],
                            toolbar: ['undo', 'redo', '|', 'bold', 'italic', "bulletedList", "numberedList"],
                            initialData: '',
                        }}
                        editor={ClassicEditor}
                        data={conditions}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            form.setFieldValue('conditions', data);
                        }}
                    /> */}


                    <Editor
                        data={conditions}
                        onChange={(data) => {
                            form.setFieldValue('conditions', data);
                        }}
                    />

                </Form.Item>

                <Form.Item
                    label="Accu Volume Currency"
                    name="accu_volume_currency"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <Input />
                </Form.Item>


                <Form.Item
                    label="Sort Level"
                    name="sort_level"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <InputNumber min={0} />
                </Form.Item>


                {/* <Form.Item
                    label="Commission Rate"
                    name="commission_rate"
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <InputNumber min={0} />
                </Form.Item> */}

                <Form.Item
                    label="Cashback Rate"
                    name="cashback_rate"
                    extra={`${(cashbackRatePercent || 0) * 100} %`}
                    rules={[{ required: true, message: 'Please fill field' }]}
                >
                    <InputNumber min={0} max={1} onChange={(text) => {
                        setCashbackRatePercent(text)
                    }} />
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
